import { Injectable, inject } from '@angular/core';
import { ApiService } from 'src/app/api/api.service';
import { Statistics } from './startsida.component';

export interface StandardNameUpdateRecordDTO {
  id: string;
  oldName: string;
  newName: string;
  mellanlagerUpdates: NameChangeStatus;
  lTLUpdates: NameChangeStatus;
  grunddataUpdates: NameChangeStatus;
}

export enum NameChangeStatus {
  PENDING = 'PENDING',
  SCHEDULED = 'SCHEDULED',
  DONE = 'DONE',
  FAILED = 'FAILED',
}

@Injectable({
  providedIn: 'root',
})
export class StartService {
  private apiService = inject(ApiService);

  public getStatistics() {
    return this.apiService.getAsObservable<Statistics>('start/statistics');
  }


  public getStandardNameUpdates() {
    const url =
      'standard-name-update' +
      '?statuses=' + NameChangeStatus.PENDING +
      '&statuses=' + NameChangeStatus.SCHEDULED+
      '&statuses=' + NameChangeStatus.FAILED;

    return this.apiService.getAsObservable<StandardNameUpdateRecordDTO[]>(url);
  }
}

